// head elements
import band from '../../assets/rarity-pics/head/band.png';
import winterCap from '../../assets/rarity-pics/head/winter-cap.png';
import sailorCap from '../../assets/rarity-pics/head/sailor-cap.png';
import textileCap from '../../assets/rarity-pics/head/textile-cap.png';
import officerCap from '../../assets/rarity-pics/head/officer-cap.png';
import nkvdCap from '../../assets/rarity-pics/head/nkvd-cap.png';
import tankCap from '../../assets/rarity-pics/head/tank-cap.png';
import baseballCap from '../../assets/rarity-pics/head/baseball-cap.png';
import capCamo from '../../assets/rarity-pics/head/cap-camo.png';
import bird from '../../assets/rarity-pics/head/bird.png';
import kevlarHelmet from '../../assets/rarity-pics/head/kevlar-helmet.png';
import ussrHelmet from '../../assets/rarity-pics/head/ussr-helmet.png';
import glasses from '../../assets/rarity-pics/head/glasses.png';
import pelotka from '../../assets/rarity-pics/head/pelotka.png';
import chechenPapakha from '../../assets/rarity-pics/head/chechen-papakha.png';
import ussrPapakha from '../../assets/rarity-pics/head/ussr-papakha.png';
import beretGreen from '../../assets/rarity-pics/head/beret-green.png';
import beretBlue from '../../assets/rarity-pics/head/beret-blue.png';
import brainsOut from '../../assets/rarity-pics/head/brains-out.png';
import kokoshnik from '../../assets/rarity-pics/head/kokoshnik.png';

// face elements
import worms from '../../assets/rarity-pics/face/worms.png';
import gasMask from '../../assets/rarity-pics/face/gas-mask.png';
import tongue from '../../assets/rarity-pics/face/tongue.png';
import glassesFace from '../../assets/rarity-pics/face/glasses.png';
import gag from '../../assets/rarity-pics/face/gag.png';
import foam from '../../assets/rarity-pics/face/foam.png';
import greenFoam from '../../assets/rarity-pics/face/green-foam.png';
import deadMouth from '../../assets/rarity-pics/face/deadmouth.png';
import rat from '../../assets/rarity-pics/face/rat.png';
import oneEyedWithCig from '../../assets/rarity-pics/face/one-eyed-with-cig.png';
import moustacheWithBlueFoam from '../../assets/rarity-pics/face/moustache-with-blue-foam.png';
import moustacheWithGreenFoam from '../../assets/rarity-pics/face/moustache-with-green-foam.png';
import moustache from '../../assets/rarity-pics/face/moustache.png';
import moustacheWithCig from '../../assets/rarity-pics/face/moustache-with-cig.png';
import cossackMoustache from '../../assets/rarity-pics/face/cossack-moustache.png';
import gingerMoustache from '../../assets/rarity-pics/face/ginger-moustache.png';
import beard from '../../assets/rarity-pics/face/beard.png';
import beardWithCig from '../../assets/rarity-pics/face/beard-with-cig.png';
import snake from '../../assets/rarity-pics/face/snake.png';
import piggy from '../../assets/rarity-pics/face/piggy.png';

// shirt
import sweater from '../../assets/rarity-pics/shirt/sweater.png';
import zipShirt from '../../assets/rarity-pics/shirt/zip-shirt.png';
import zipTunic from '../../assets/rarity-pics/shirt/zip-tunic.png';
import tattoo from '../../assets/rarity-pics/shirt/tattoo.png';
import chain from '../../assets/rarity-pics/shirt/chain.png';
import kufiya from '../../assets/rarity-pics/shirt/kufiya.png';
import sweaterTankTop from '../../assets/rarity-pics/shirt/sweater-tank-top.png';
import blueShirt from '../../assets/rarity-pics/shirt/blue-shirt.png';
import grayShirt from '../../assets/rarity-pics/shirt/gray-shirt.png';
import camoTankTop from '../../assets/rarity-pics/shirt/camo-tank-top.png';
import oliveTankTop from '../../assets/rarity-pics/shirt/olive-tank-top.png';
import tacticalVest from '../../assets/rarity-pics/shirt/tactical-vest.png';
import tacticalVestWithCross from '../../assets/rarity-pics/shirt/tactical-vest-with-cross.png';
import belt from '../../assets/rarity-pics/shirt/belt.png';
import molleVest from '../../assets/rarity-pics/shirt/molle-vest.png';
import telogreika from '../../assets/rarity-pics/shirt/telogreika.png';
import bullets from '../../assets/rarity-pics/shirt/bullets.png';
import skeleton from '../../assets/rarity-pics/shirt/skeleton.png';
import sailorTankTopBlue from '../../assets/rarity-pics/shirt/sailor-tank-top-blue.png';
import sailorTankTopRed from '../../assets/rarity-pics/shirt/sailor-tank-top-red.png';

import styles from './styles.module.css';
import RarityRow from './row';


function RarityBlock() {
  const headElements = [
    {
      image: band,
      percent: 80,
      name: "Bandage"
    },
    {
      image: textileCap,
      percent: 5,
      name: "Bandana camo"
    },
    {
      image: baseballCap,
      percent: 5,
      name: "Baseball cap"
    },
    {
      image: capCamo,
      percent: 5,
      name: "Cap camo"
    },
    {
      image: kevlarHelmet,
      percent: 5,
      name: "Kevlar helmet"
    },
    {
      image: ussrHelmet,
      percent: 5,
      name: "USSR helmet"
    },
    {
      image: beretGreen,
      percent: 5,
      name: "Green beret"
    },
    {
      image: beretBlue,
      percent: 5,
      name: "Blue beret"
    },
    {
      image: brainsOut,
      percent: 5,
      name: "Brains out",
      itemType: "uncommon"
    },
    {
      image: tankCap,
      percent: 5,
      name: "Tank cap",
      itemType: "uncommon"
    },
    {
      image: winterCap,
      percent: 15,
      name: "Ushanka",
      itemType: "uncommon"
    },
    {
      image: officerCap,
      percent: 5,
      name: "Officer cap",
      itemType: "uncommon"
    },
    {
      image: bird,
      percent: 5,
      name: "Bird",
      itemType: "uncommon"
    },
    {
      image: glasses,
      percent: 5,
      name: "Glasses",
      itemType: "uncommon"
    },
    {
      image: nkvdCap,
      percent: 5,
      name: "NKVD cap",
      itemType: "rare"
    },
    {
      image: sailorCap,
      percent: 5,
      name: "Sailor cap",
      itemType: "rare"
    },
    {
      image: pelotka,
      percent: 5,
      name: "Pilotka",
      itemType: "rare"
    },
    {
      image: chechenPapakha,
      percent: 5,
      name: "Chechen papakha",
      itemType: "rare"
    },
    {
      image: ussrPapakha,
      percent: 5,
      name: "USSR papakha",
      itemType: "legendary"
    },
    {
      image: kokoshnik,
      percent: 5,
      name: "Kokoshnik",
      itemType: "legendary"
    },
  ];

  const shirtElements = [
    {
      image: sweater,
      percent: 5,
      name: "Sweater",
      itemType: "common",
    },
    {
      image: zipShirt,
      percent: 5,
      name: "Zip shirt",
    },
    {
      image: sweaterTankTop,
      percent: 5,
      name: "Sweater tank top"
    },
    {
      image: oliveTankTop,
      percent: 5,
      name: "Olive tank top"
    },
    {
      image: tacticalVest,
      percent: 5,
      name: "Tactical vest"
    },
    {
      image: molleVest,
      percent: 5,
      name: "Molle vest"
    },
    {
      image: skeleton,
      percent: 5,
      name: "Skeleton"
    },
    {
      image: sailorTankTopBlue,
      percent: 5,
      name: "Sailor tank top blue"
    },
    {
      image: camoTankTop,
      percent: 5,
      name: "Camo tank top",
      itemType: "uncommon"
    },
    {
      image: blueShirt,
      percent: 5,
      name: "Blue shirt",
      itemType: "uncommon"
    },
    {
      image: grayShirt,
      percent: 5,
      name: "Gray shirt",
      itemType: "uncommon"
    },
    {
      image: zipTunic,
      percent: 5,
      name: "Zip tunic",
      itemType: "uncommon"
    },
    {
      image: tacticalVestWithCross,
      percent: 5,
      name: "Tactical vest with cross",
      itemType: "uncommon"
    },
    {
      image: telogreika,
      percent: 5,
      name: "Telogreika",
      itemType: "uncommon"
    },
    {
      image: chain,
      percent: 5,
      name: "Chain",
      itemType: "rare"
    },
    {
      image: kufiya,
      percent: 5,
      name: "Kufiya",
      itemType: "rare"
    },
    {
      image: bullets,
      percent: 5,
      name: "Bullets",
      itemType: "rare"
    },
    {
      image: sailorTankTopRed,
      percent: 5,
      name: "Sailor tank top red",
      itemType: "rare"
    },
    {
      image: tattoo,
      percent: 5,
      name: "Tattoo",
      itemType: "legendary",
    },
    {
      image: belt,
      percent: 5,
      name: "Belt",
      itemType: "legendary",
    },
  ]
  const faceElements = [
    {
      image: worms,
      percent: 5,
      name: "Worms"
    },
    {
      image: foam,
      percent: 5,
      name: "Foam"
    },
    {
      image: moustacheWithBlueFoam,
      percent: 5,
      name: "Moustache with blue foam"
    },
    {
      image: moustacheWithGreenFoam,
      percent: 5,
      name: "Moustache with green foam"
    },
    {
      image: moustache,
      percent: 5,
      name: "Moustache"
    },
    {
      image: moustacheWithCig,
      percent: 5,
      name: "Moustache with cig"
    },
    {
      image: gingerMoustache,
      percent: 5,
      name: "Ginger moustache"
    },
    {
      image: beard,
      percent: 5,
      name: "Beard"
    },
    {
      image: beardWithCig,
      percent: 5,
      name: "Beard with cig"
    },
    {
      image: greenFoam,
      percent: 5,
      name: "Green foam",
      itemType: "uncommon"
    },
    {
      image: deadMouth,
      percent: 5,
      name: "Deadmouth",
      itemType: "uncommon"
    },
    {
      image: cossackMoustache,
      percent: 5,
      name: "Budyonny moustache",
      itemType: "uncommon"
    },
    {
      image: piggy,
      percent: 5,
      name: "Piggy",
      itemType: "uncommon"
    },
    {
      image: tongue,
      percent: 5,
      name: "Tongue",
      itemType: "uncommon"
    },
    {
      image: rat,
      percent: 5,
      name: "Rat",
      itemType: "rare"
    },
    {
      image: snake,
      percent: 5,
      name: "Snake",
      itemType: "rare"
    },
    {
      image: glassesFace,
      percent: 5,
      name: "Glasses",
      itemType: "rare"
    },
    {
      image: gasMask,
      percent: 5,
      name: "Gas mask",
      itemType: "rare"
    },
    {
      image: oneEyedWithCig,
      percent: 5,
      name: "One-eyed with cig",
      itemType: "legendary"
    },
    {
      image: gag,
      percent: 5,
      name: "Clap",
      itemType: "legendary"
    },
  ];

  return (
    <div id="rarity" className={styles.wrapper}>
        <div className={styles.container}>
            <div className={styles.headingBlock}>
                <span className={styles.subheading}>THE COLLECTION</span>
                <h1 className={styles.heading}>Rarity list</h1>
                <p className={styles.headingParagraph}>Here are all the traits of our beautiful collection. We don't measure our arts by names like "Common", "Epic" etc. You can see all the percents by yourself.</p>
            </div>
            <RarityRow heading="Head" items={headElements} />
            <RarityRow heading="Face" items={faceElements} />
            <RarityRow heading="Shirt" items={shirtElements} />
        </div>
    </div>
  );
}

export default RarityBlock;
